import { combineReducers } from "redux";
import { feacherReducer } from "./feature";
import { Loading } from "./loading";
import { optionReducer } from "./option";
import { pictureReducer } from "./picture";
import { Texture } from "./texture";
import {
  locationOfCarpetReducer,
  paramsOfTextureReducer,
  secendCarpetReducer,
  sizeChangeReducer,
} from "./paramsOfTexture";

export const Reducers = combineReducers({
  texture: Texture,
  loading: Loading,
  picture: pictureReducer,
  feature: feacherReducer,
  option: optionReducer,
  paramsOfTexture: paramsOfTextureReducer,
  resetPositionCarpet: locationOfCarpetReducer,
  secondCarpet: secendCarpetReducer,
  sizeChange: sizeChangeReducer,
});
